import { ImageConstant } from "../images";

export const AppConstants = {
  businessPoints: [
    "Monthly Invoice payment",
    "Exclusive offers",
    "Free delivery for limited orders",
    "Special membership card",
    "Premium customer service",
  ],
  nonBusinessPoints: [
    "Special discounts via friend referral code",
    "Free account",
    "Secure payment method",
    "24/7 customer support",
    "Cheap rates",
  ],
  FAQ: [
    // {
    //   question: "How to report the Driver?",
    //   answer:
    //     "For this purpose please contact at our telephone number:  +1 (647) 581-8064 or email us with your order number at info@peaktimecourier.com",
    // },
    {
      question: "How to register as a driver or dispatcher?",
      answer: `For registering as a driver or dispatcher please email us at career@peaktimecourier.com while mentioning the subject line as applying for driver/dispatcher in Peaktime courier 
            after that, we will give you a form to fill if everything goes right we will call you for registration`,
    },
    {
      question: "Need Any Assistance?",
      answer:
        "For any assistance please email us at info@peaktimecourier.com or call of helpline number: +1 (647) 581-8064",
    },
    {
      question: "How far can we deliver?",
      answer:
        "We are GTA based company and we also deliver to surrounding area and long distance.",
    },
    {
      question: "What is Base Fare? ",
      answer: "the minimum base fare is $7",
    },
    {
      question:
        "What is the maximum weight we can deliver for non-business customers?",
      answer: "The maximum weight limit is 120 Pound",
    },
    {
      question:
        "Can I change or cancel my delivery order after it has been placed?",
      answer:
        "In order to change the delivery or cancel an order please contact info@peaktimecourier.com",
    },
    {
      question: "What happens if my delivery is lost or damaged during transit",
      answer:
        "We will provide maximum damage or lost maximum $150 depending on the value of order",
    },
    // {
    //   question: "What is your return policy for items delivered to me?",
    //   answer:
    //     "Please visit our terms & conditions page for complete information",
    // },
  ],
  chooseOptions: [
    {
      Heading: "Affordable Rates",
      Description:
        "We offer the most affordable and competitive rates for courier services in the entire GTA and surrounding areas and long distances . ",
      image: ImageConstant.affordableRates,
    },
    {
      Heading: "Real-Time Tracking",
      Description:
        "We provide easy-to-navigate and accurate real-time order tracking",
      image: ImageConstant.realTime,
    },
    {
      Heading: "24/7 Ordering",
      Description:
        "Our easy-to-use website and mobile app let you place orders at any time of the day. ",
      image: ImageConstant.ordering,
    },
    {
      Heading: "Instant Quote",
      Description:
        "Get an instant and accurate price estimation on your selected destination.",
      image: ImageConstant.instantQuote,
    },
    {
      Heading: "Free Account",
      Description:
        "Take advantage of all of our services with an easy-to-set-up accessible business account. ",
      image: ImageConstant.freeAccount,
    },
    {
      Heading: "Promotions",
      Description:
        "Get exclusive offers and gifts via special promotion offers.",
      image: ImageConstant.promotion,
    },
  ],
  Prices: [
    {
      service_id: 1,
      cut_off_time: "3:30 PM",
      service_type: "90 mins",
      price: "17",
    },
    {
      service_id: 2,
      cut_off_time: "3:30 PM",
      service_type: "2 hours",
      price: "13",
    },
    {
      service_id: 3,
      cut_off_time: "1:00 PM",
      service_type: "4 hours",
      price: "9",
    },
    {
      service_id: 4,
      cut_off_time: "11:30 AM",
      service_type: "5.5 hours (Same Day)",
      price: "8",
    },
    {
      service_id: 5,
      cut_off_time: "5:00 PM",
      service_type: "5-8 hours (after hour)",
      price: "20",
    },
    {
      service_id: 6,
      cut_off_time: "before 10:30 AM",
      service_type: "Next Day before 10:30 AM",
      price: "16",
    },
    {
      service_id: 7,
      cut_off_time: "before 11:30 AM",
      service_type: "Next Day before 11:30 AM",
      price: "10",
    },
    {
      service_id: 8,
      cut_off_time: "Midnight",
      service_type: "Next Day befor 2PM",
      price: "9",
    },
    {
      service_id: 9,
      cut_off_time: "Midnight",
      service_type: "Next Day before 5PM",
      price: "7",
    },
    {
      service_id: 10,
      cut_off_time: null,
      service_type: "Future Date Schedule 1PM to 5PM",
      price: "8",
    },
    {
      service_id: 11,
      cut_off_time: null,
      service_type: "Future Date Schedule 10AM to 2PM",
      price: "8",
    },
  ],
};

export const APIConstants = {
  apiUrl: "https://admin.peaktimecourier.com/api/",
  token: {
    Authorization:
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiMDA5ZDAxZTI4OTVjYjg4MjZlYTcyMDYxZjE0NDgyYjU3ZTUxNDMzMTQ3ZTg0ZjAxNzAxM2YzZjM0M2RiYzhkZWRlOWE1YjM0MzgzOWQ1YzkiLCJpYXQiOjE3ODY5OTkyMjksIm5iZiI6MTc4Njk5OTIyOSwiZXhwIjoxODE4NTM1MjI5LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.THqdy1o_k-GJm8key8F_64OFZOIsBad-wPD6IB66xguIDWA6z4UIv9zagpbsturBsRfcEOBKI01KnBj7JbKrdimeXOSKTDYQHnqm-nk9CsK5ZuANw4IH3pEptiIjFC6Jp1YhdevabHGwPnE-Vw2vsI9Tyib1gYByoswfwuLZYqJk923zSRQJN7zA16gI9_uLpAKOM7iIHxBPBS_o2zCFgKoK5QetP6xrvzZAN9lRedYY6a_05g_aai2AOTUOVsw5Q1o0U8REUbU-wWXL4b7fbTbx4eWhxM2QjfRuETc1OdJL6899013nYpyvNcKl4yIgzJ-K6TdrYawAe4qL-LyHNW3rUygDydQLTLD9L66E0WWrLrdxz9dI2MwOr_GIGq1iRi48z0ppI97nVvycbtSia61YlkbP0OMbE3y-wpt48XMM39sKMHUDGFIttAL7CLUk0bGlicdt3nw4PTWloUmFvc7xMGRYqvdCaXaBmHgpdL6mWLnC445ygFlTQ0wOMdRJBIZOzbj0utjvYytMi-QAY7nV5Cg-L4vVHkNt1S9TVaeqBkc1IDfQsesCSULsBvZi9op3wuOqoEFbXaYF1lYQPhGDtSM2_4EGsjjptUdGhndSEIu4olzPuWJWiVYVbAdGkomRESldMZSBqHI6Fks5pKqS-LsVc8OUc23wKsQ9BEw",
  },
};
